import { render, staticRenderFns } from "./SVGImage.vue?vue&type=template&id=b8409ec4&"
import script from "./SVGImage.vue?vue&type=script&lang=js&"
export * from "./SVGImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports